import React, { useEffect } from "react";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import Listing from "../../lessons/Listing";
import HeroSection from "../../../layout/HeroSection";
import Loader from "../../../components/other/Loader";
import { useDispatch, useSelector } from "react-redux";
import { pageRoutes } from "../../../routes/pageRoutes";
import { fetchSportsman } from "../../../redux/action/weightAction";
const Sportsmans = () => {
  const dispatch = useDispatch();
  const { sportsmans30lbList, isLoading } = useSelector(
    (state) => state?.weightReducer
  );

  useEffect(() => {
    dispatch(fetchSportsman());
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <div>
        <Header />
        <HeroSection
          label={<h1 class="mb-3">{"Sportsmans (30lb.)"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            {
              name: "Sportsmans (30lb.)",
              path: `${pageRoutes?.home}/`,
            },
          ]}
        />

        <Listing contentData={sportsmans30lbList} />

        <Footer />
      </div>
    </>
  );
};

export default Sportsmans;
